import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import "./App.css";
import "antd/dist/antd.min.css";
import { Provider } from "react-redux";
import store from "./redux/store";

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <main>
        <AppRoutes />
      </main>
    </BrowserRouter>
  </Provider>
);

export default App;
